module.exports = __webpack_public_path__ + "img/motorway_11x2.36f6f494.svg";